import { render, staticRenderFns } from "./application.vue?vue&type=template&id=63f79870&scoped=true&lang=pug&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f79870",
  null
  
)

export default component.exports